import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import PaperButton from 'ember-paper/components/paper-button';
import PaperDialog from 'ember-paper/components/paper-dialog';
import PaperDialogActions from 'ember-paper/components/paper-dialog-actions';
import PaperDialogContent from 'ember-paper/components/paper-dialog-content';
import PaperIcon from 'ember-paper/components/paper-icon';
import PaperToolbar from 'ember-paper/components/paper-toolbar';
import PaperToolbarTools from 'ember-paper/components/paper-toolbar-tools';
import type GoogleDriveService from '@linc-technologies/linced-common/services/google-drive';

// GoogleDriveShareConfirmDialog asks the user to share a private Google Drive
// file before it is embedded. It shows while googleDrive.shareRequest is set.
// Each app renders it once, in its application template.
export default class GoogleDriveShareConfirmDialog extends Component {
  @service declare googleDrive: GoogleDriveService;

  confirm = () => this.googleDrive.confirmShare();

  cancel = () => this.googleDrive.cancelShare();

  // hideThumbnail hides a thumbnail that does not load.
  hideThumbnail = (event: Event) => {
    (event.currentTarget as HTMLImageElement).hidden = true;
  };

  <template>
    {{#if this.googleDrive.shareRequest}}
      <PaperDialog @escapeToClose={{false}} @clickOutsideToClose={{false}}>
        <PaperToolbar>
          <PaperToolbarTools>
            <h2>Share "{{this.googleDrive.shareRequest.fileName}}"</h2>
            <span class="flex"></span>
            <PaperButton @iconButton={{true}} @onClick={{this.cancel}}>
              <PaperIcon @icon="close" />
            </PaperButton>
          </PaperToolbarTools>
        </PaperToolbar>

        <PaperDialogContent @class="flex">
          {{#if this.googleDrive.shareRequest.thumbnailUrl}}
            <div class="layout-row layout-align-center-center md-padding">
              <img
                alt={{this.googleDrive.shareRequest.fileName}}
                src={{this.googleDrive.shareRequest.thumbnailUrl}}
                {{on "error" this.hideThumbnail}}
              />
            </div>
          {{/if}}
          <h3>This document is set to private</h3>
          <p>
            To embed it, we'll update its permissions so anyone with the link
            can view it.
          </p>
        </PaperDialogContent>

        <PaperDialogActions @class="layout-row layout-align-center-center">
          <div class="layout-column">
            <PaperButton
              data-test-share-confirm
              @onClick={{this.confirm}}
              @primary={{true}}
              @raised={{true}}
            >
              Update to anyone with the link can view
            </PaperButton>
            <PaperButton data-test-share-cancel @onClick={{this.cancel}}>
              Cancel
            </PaperButton>
          </div>
        </PaperDialogActions>
      </PaperDialog>
    {{/if}}
  </template>
}
